// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2mSK9","messages":"Chat_messages__jtkMe","dateDivider":"Chat_dateDivider__SCBnp"};